import { Provider, client } from '@benefits/remote-config';

const RemoteConfigProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Provider client={client}>{children}</Provider>;
};

export default RemoteConfigProvider;
